
<div class="page-not-found-style">
    <div class="not-found-background">
        <div class="font-color">
            <h1 class="not-found">404</h1>
            <p class="not-found-message">{{message | customTranslation: translationsArray}}</p>
        </div>
    </div>
</div>
